/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from '../../../components/ComponentTitle';
import { ComponentSourcetitle } from '../../../components/ComponentSourcetitle';
import { ComponentPreloader } from '../../../components/ComponentPreloader';
import { ComponentFootnote } from '../../../components/ComponentFootnote';
import { useData2 } from '../data/useData2';
import { useChart2 } from '../transformers/useChart2';
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from '../../../../charts/components/HighchartsChart';
import { ComponentContextReadyState } from "@sa/rep-core";

export const ComponentChart2: React.FC<{ context: ContextReport1 }> = (props) => {
  const context = props.context;
  const payload = useHookSubscribe(null, context.payloadChart2);
  const commodities = useHookSubscribe(null, context.commodities);
  const netTradeCountries = useHookSubscribe(null, context.netTradeCountries$); 
  const data = useData2(payload);
  const chartData = useChart2(data, netTradeCountries);
  const source = useHookSubscribe(null, context.sources$);

  const [loading, setLoading] = React.useState(false);
  const [dataHash, setDataHash] = React.useState("");
  React.useEffect(() => {
    const currentDataHash = JSON.stringify(chartData);
    if (context.readyState === ComponentContextReadyState.Loading && !loading) {
      setLoading(true);
      setDataHash(currentDataHash);
    }

    if (context.readyState === ComponentContextReadyState.Loaded && loading && currentDataHash !== dataHash) {
      setLoading(false);
    }
  }, [chartData, context.readyState]);

  if (window['exportMode']) {
    window["exportReady"] = chartData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (!window['exportMode'] && (!chartData || loading || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }
  const isSugarcane = String(commodities && commodities[0]) === "120000";
  return <>
    <ComponentTitle>Net trade*</ComponentTitle>
    <ComponentSourcetitle>* Top 5 net exporters and importers{isSugarcane ? '. **Net trade values refer to difference between exports and imports of Raw Sugar' : null}</ComponentSourcetitle>
    <HighchartsChart data={chartData} loader={<ComponentPreloader />} />
  </>
};
